import store from './index'
import WorkbenchWCanvasSlotActionsGenerator from './WorkbenchWCanvasSlotActionsGenerator'
import { createModule } from '@/appComponents/oldWorkbench/targetDefinition'
import networks from '@/appLogic/networks/store'

// designed to be an interface for a new workbench store
class WorkbenchWCanvasBaseStore {
  constructor (namespace) {
    this.namespace = namespace
    this.state = store.state
    this.getters = store.getters
    this.mutations = store.mutations
  }

  additionalState () {
    throw new Error('Please override this and return an object with the additional state for your new workbench')
  }

  additionalGetters () {
    throw new Error('Please override this and return an object with the additional getters for your new workbench')
  }

  additionalMutations () {
    throw new Error('Please override this and return an object with the additional mutations for your new workbench')
  }

  createActions () {
    // use this pattern for making your actions
    const baseActions = new WorkbenchWCanvasSlotActionsGenerator()
    return baseActions.generateActions()
  }

  additionalModules () {
    // Only add more modules if you feel that they are needed
    // if you add more modules make sure it is a function that returns an object
    return false
  }

  createModules () {
    if (!this.namespace) {
      throw new Error('WorkbenchWCanvasBaseStore target definition module needs a namespace ex: "las", "sm"')
    }
    const targetDefinition = createModule(this.namespace)
    const modules = {
      targetDefinition,
      networks
    }
    const additional = this.additionalModules()
    if (additional) {
      return {
        ...modules,
        ...additional
      }
    }
    return modules
  }

  create () {
    const base = this
    return {
      state () {
        return {
          ...base.state,
          ...base.additionalState()
        }
      },
      getters: {
        ...this.getters,
        ...this.additionalGetters()
      },
      mutations: {
        ...this.mutations,
        ...this.additionalMutations()
      },
      actions: this.createActions(),
      modules: this.createModules()
    }
  }
}

export default WorkbenchWCanvasBaseStore



// WEBPACK FOOTER //
// ./src/app/views/workbenchCanvas/store/WorkbenchWCanvasBaseStore.js